class AbstractType
{
    toFirestore = (value) => value;
    fromFirestore = (value) => value;

    test = (value) => true;
}

export default AbstractType;